import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SaleConversionRateInfo } from '../../model/SaleConversionRateInfo.model';

export interface ConversionRateDialogData {
  conversionRates: SaleConversionRateInfo[];
  teamName: string;
  year: string;
}

@Component({
  selector: 'app-conversion-rate-dialog',
  templateUrl: './conversion-rate-dialog.component.html',
  styleUrls: ['./conversion-rate-dialog.component.css']
})
export class ConversionRateDialogComponent {
  displayedColumns: string[] = ['no', 'saleTargetEmpName', 'totalLead', 'win', 'loss', 'pending', 'conversionRate'];

  constructor(
    public dialogRef: MatDialogRef<ConversionRateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConversionRateDialogData
  ) {}

  calculateConversionRate(row: SaleConversionRateInfo): string {
    const totalLead = row.TotalLead || 0;
    const win = row.Win || 0;
    return totalLead > 0 ? ((win / totalLead) * 100).toFixed(1) + '%' : '0%';
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  displayIndex(index: number): number {
    return index + 1;
  }
}
